const patterns: Record<string, RegExp> = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  name: /^[^`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/\s][^`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]*$/,
};

export { patterns };
